import React, { Fragment } from 'react';
import { SlideLayout } from './SlideLayout';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Slide3_System() {
  const steps = ['Attract', 'Engage', 'Screen', 'Qualify', 'Interview', 'Commit', 'Onboard', 'Integrate', 'Train', 'Launch', 'Retain'];
  return <SlideLayout data-id="element-67">
      <div className="flex flex-col h-full justify-center items-center space-y-16" data-id="element-68">
        <div className="text-center space-y-6 max-w-4xl" data-id="element-69">
          <h2 className="text-4xl md:text-6xl font-bold text-white leading-tight" data-id="element-70">
            High-Growth Companies Don't "Hire."
            <br data-id="element-71" />
            <span className="text-emerald-400" data-id="element-72">
              They Run a Recruiting System.
            </span>
          </h2>
          <p className="text-xl text-slate-400" data-id="element-73">
            Predictable recruiting isn't about volume. It's about control across
            every step.
          </p>
        </div>

        <div className="w-full px-4" data-id="element-74">
          {/* Desktop: Single horizontal line */}
          <div className="hidden md:flex items-center justify-center mx-auto py-4" data-id="element-75">
            {steps.map((step, idx) => <Fragment key={step} data-id="element-76">
                <motion.div className="flex flex-col items-center group" initial={{
              scale: 0.8,
              opacity: 0
            }} animate={{
              scale: 1,
              opacity: 1
            }} transition={{
              delay: idx * 0.08 + 0.2
            }} data-id="element-77">
                  <div className="w-20 h-20 rounded-full bg-slate-900 border-2 border-slate-700 flex items-center justify-center group-hover:border-emerald-500 transition-colors duration-300 shadow-xl relative z-10" data-id="element-78">
                    <span className="text-sm font-bold text-white tracking-wide text-center px-2" data-id="element-79">
                      {step}
                    </span>
                  </div>
                  <span className="mt-2 text-sm text-slate-600 font-medium" data-id="element-80">
                    {String(idx + 1).padStart(2, '0')}
                  </span>
                </motion.div>
                {idx < steps.length - 1 && <motion.div className="flex items-center mx-2" initial={{
              scaleX: 0,
              opacity: 0
            }} animate={{
              scaleX: 1,
              opacity: 1
            }} transition={{
              delay: idx * 0.08 + 0.25
            }} data-id="element-81">
                    <ArrowRight className="w-5 h-5 text-slate-700" data-id="element-82" />
                  </motion.div>}
              </Fragment>)}
          </div>

          {/* Mobile: Single column with arrows */}
          <div className="md:hidden flex flex-col items-center space-y-3" data-id="element-83">
            {steps.map((step, idx) => <Fragment key={step} data-id="element-84">
                <motion.div className="flex items-center space-x-4 w-full max-w-xs" initial={{
              x: -20,
              opacity: 0
            }} animate={{
              x: 0,
              opacity: 1
            }} transition={{
              delay: idx * 0.08 + 0.2
            }} data-id="element-85">
                  <span className="text-slate-600 font-bold text-sm w-8" data-id="element-86">
                    {String(idx + 1).padStart(2, '0')}
                  </span>
                  <div className="flex-1 h-14 rounded-lg bg-slate-900 border-2 border-slate-700 flex items-center justify-center hover:border-emerald-500 transition-colors" data-id="element-87">
                    <span className="text-sm font-bold text-white tracking-wide" data-id="element-88">
                      {step}
                    </span>
                  </div>
                </motion.div>
                {idx < steps.length - 1 && <motion.div initial={{
              opacity: 0
            }} animate={{
              opacity: 1
            }} transition={{
              delay: idx * 0.08 + 0.3
            }} data-id="element-89">
                    <ArrowRight className="w-5 h-5 text-slate-700 rotate-90" data-id="element-90" />
                  </motion.div>}
              </Fragment>)}
          </div>
        </div>
      </div>
    </SlideLayout>;
}